<template>
  <!-- Sect Modal -->
  <div v-if="gameState.inSectModal" class="sect-modal" @click="closeModal">
    <div class="sect-card" @click.stop>
      <!-- Fixed Header -->
      <div class="sect-header">
        <h3>选择宗门</h3>
        <p>加入宗门可以获得宗门特有的修炼资源和技能传承。</p>
      </div>

      <!-- Scrollable Content -->
      <div class="sect-content">
        <div class="sect-list">
        <button
          v-for="sect in availableSects"
          :key="sect.name"
          @click="joinSect(sect.name)"
          class="sect-button"
          :class="{ 'current-sect-btn': gameState.sect === sect.name }"
        >
            <div class="sect-name">{{ sect.name }}</div>
            <div class="sect-description">{{ sect.description }}</div>
            <div class="sect-bonuses">
              <div v-for="bonus in sect.bonuses" :key="bonus" class="sect-bonus">{{ bonus }}</div>
            </div>
            <div v-if="gameState.sect === sect.name" class="current-sect">当前宗门</div>
          </button>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="sect-footer">
        <button @click="handleCloseClick" class="close-btn">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import { joinSect as joinSectFunc, listSects, getAllSects } from '../sects.js';
import gameController from '../game-controller/GameController.js';

export default {
  name: 'SectModal',
  props: {
    gameState: {
      type: Object,
      required: true
    },
    stateManager: {
      type: Object,
      required: true
    }
  },
  computed: {
    availableSects() {
      return getAllSects();
    }
  },
  methods: {
    joinSect(sectName) {
      // 先检查是否已经加入该宗门
      if (this.gameState.sect === sectName) {
        this.$emit('sect-result', `你已经是 ${sectName} 的弟子了。`);
        this.closeModal();
        return;
      }

      // 尝试加入宗门
      const result = joinSectFunc(this.gameState, sectName);
      if (typeof result === 'string') {
        this.$emit('sect-result', result);
        // 保存状态
        gameController.stateManager.saveState();
      } else if (Array.isArray(result)) {
        this.$emit('sect-result', result.join('\n'));
        // 保存状态
        gameController.stateManager.saveState();
      } else {
        // 如果没有返回值，给出默认成功消息
        this.$emit('sect-result', `你加入了 ${sectName}。`);
        // 保存状态
        gameController.stateManager.saveState();
      }
      this.closeModal();
    },
    closeModal() {
      this.gameState.inSectModal = false;
    },
    handleCloseClick() {
      this.closeModal();
    }
  }
};
</script>

<style scoped>
.sect-modal {
  position: absolute;
  inset: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.8);
  z-index: 250;
  backdrop-filter: blur(2px);
}

.sect-card {
  background: #071328;
  border-radius: 12px;
  border: 1px solid #334155;
  color: #e6eef8;
  min-width: 400px;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.sect-header {
  flex-shrink: 0;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #334155;
}

.sect-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

.sect-footer {
  flex-shrink: 0;
  padding: 16px 20px 20px 20px;
  border-top: 1px solid #334155;
  display: flex;
  justify-content: center;
}

.sect-card h3 {
  margin: 0;
  font-size: 18px;
  color: #60a5fa;
  text-align: center;
  border-bottom: 1px solid #334155;
  padding-bottom: 8px;
}

.sect-card p {
  margin: 0;
  color: #cbd5e1;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
}

.sect-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sect-button {
  padding: 16px;
  border: 2px solid #475569;
  background: transparent;
  color: #cbd5e1;
  cursor: pointer;
  border-radius: 8px;
  text-align: left;
  transition: all 0.3s ease;
  position: relative;
}

.sect-button:hover:not(.current-sect-btn) {
  border-color: #60a5fa;
  background: rgba(96, 165, 250, 0.1);
  transform: translateY(-2px);
}

.sect-button.current-sect-btn {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
}

.sect-button.current-sect-btn:hover {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.2);
  transform: none;
}

.sect-name {
  font-size: 16px;
  font-weight: bold;
  color: #dbeafe;
  margin-bottom: 4px;
}

.sect-description {
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 8px;
}

.sect-bonuses {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.sect-bonus {
  background: #334155;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #60a5fa;
}

.current-sect {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #16a34a;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  border-top: 1px solid #334155;
}

.close-btn {
  padding: 8px 16px;
  border: 1px solid #dc2626;
  background: transparent;
  color: #dc2626;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #dc2626;
  color: white;
}

/* 适配移动设备 */
@media (max-width: 900px) {
  .sect-card {
    min-width: 90vw;
  }

  .sect-header {
    padding: 16px 16px 12px 16px;
  }

  .sect-content {
    padding: 12px 16px;
  }

  .sect-footer {
    padding: 12px 16px 16px 16px;
  }

  .sect-button {
    padding: 12px;
  }

  .sect-name {
    font-size: 14px;
  }

  .sect-description {
    font-size: 13px;
  }

  .sect-bonuses {
    gap: 4px;
  }

  .sect-bonus {
    font-size: 11px;
    padding: 1px 4px;
  }
}
</style>
